export function roleGQLFields(fields) {
    return `
    id
    name
    type
    description
    visible
    ${fields === 'all' ? 'scopes' : ''}
  `;
}
//# sourceMappingURL=role.fields.js.map